import * as http from '../../../../../utils/apis';
import { PIE_CHART_PER_PAGE } from '../../../../../config/constants';

const upgradeApi = {
    getAll: async (page) => {
        const res = await http.get(`cms-api/dashboard/upgrade`, {
            page: page,
            perPage: PIE_CHART_PER_PAGE,
        });
        return res;
    },
};

export default upgradeApi;
